'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hash = require('../vendor/glamor/hash');

var _hash2 = _interopRequireDefault(_hash);

var _css = require('./css');

var _css2 = _interopRequireDefault(_css);

var _GlobalStyle = require('../models/GlobalStyle');

var _GlobalStyle2 = _interopRequireDefault(_GlobalStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_NameGenerator = require('../types').babelPluginFlowReactPropTypes_proptype_NameGenerator || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_Interpolation = require('../types').babelPluginFlowReactPropTypes_proptype_Interpolation || require('prop-types').any;

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

exports.default = function (nameGenerator) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = _css2.default.apply(undefined, [strings].concat(interpolations));
    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
    var name = nameGenerator(hash);
    var keyframes = new _GlobalStyle2.default(rules, '@keyframes ' + name);
    var keyframesWebkit = new _GlobalStyle2.default(rules, '@-webkit-keyframes ' + name);
    keyframes.generateAndInject();
    keyframesWebkit.generateAndInject();
    return name;
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/constructors/keyframes.js
// module id = 520
// module chunks = 0